var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:{ icon: true, [`icon-${_vm.icon}`]: true },style:({ 'font-size': `${_vm.size}px`, color: _vm.color })})
}
var staticRenderFns = []

export { render, staticRenderFns }